import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { PlatformEnum } from '@panamax/app-state';
import { ExceptionResolution } from '@usf/ngrx-order';
import { Product } from 'src/app/shared/models/product.model';
import { ExceptionType } from '../../../pages/order-exceptions/constants/order-exception-type.enum';
import { EmittedFlippedProductNumber } from '../../../pages/order-exceptions/models/emitted-flipped-product-number.model';
import { EmittedPartialFlag } from '../../../pages/order-exceptions/models/emitted-partial-flag-selection.model';
import { EmittedResolution } from '../../../pages/order-exceptions/models/emitted-resolution.model';
import { EmittedSearchForSubs } from '../../../pages/order-exceptions/models/emitted-search-for-subs.model';

@Component({
  template: '',
})
export class SubstitutionRowBaseComponent implements OnInit, OnChanges {
  @Input() exceptionResolution: ExceptionResolution;
  @Input() productMap: Map<number, Product>;
  @Input() searchForSubsMap: Map<number, string>;
  @Input() exceptionType: ExceptionType;
  @Input() platformEnum: PlatformEnum;
  @Input() masterListRestricted: boolean;
  @Input() hideSearchForSubs: boolean;

  @Output() exceptionResolved = new EventEmitter();
  @Output() searchForSubsClicked = new EventEmitter();
  @Output() compareProductsClicked = new EventEmitter();
  @Output() partialFlagResolved = new EventEmitter<EmittedPartialFlag>();
  @Output()
  substituteProductFlipped = new EventEmitter<EmittedFlippedProductNumber>();
  @Output() editRowResolved = new EventEmitter<ExceptionResolution>();
  @Output() cancelEditRow = new EventEmitter<ExceptionResolution>();

  isSubstituteShelfVisible = false;
  exceptionTypeEnum = ExceptionType;
  hasSearchForSubSelected = false;
  isExpanded = false;
  sendReservedCases: boolean = null;
  selectSubstitute: boolean = null;

  constructor() {}

  ngOnInit(): void {
    this.updateHasSearchForSubs();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.exceptionResolution?.currentValue) {
      this.updateHasSearchForSubs();
    }
  }

  onSendReservedChange(event: any): void {
    const value = event.detail.value;
    this.sendReservedCases = value === 'yes';
    if (this.sendReservedCases === true) {
      this.selectSubstitute = null;
    }
    // TODO: Implement business logic for handling the user's choice
  }

  onSelectSubstituteChange(event: any): void {
    const value = event.detail.value;
    this.selectSubstitute = value === 'yes';
    // TODO: Implement business logic for handling the substitute choice
  }

  showSubstitutesShelf() {
    this.isSubstituteShelfVisible = true;
  }

  showSearch() {
    this.isExpanded = !this.isExpanded;
  }

  resolveExceptionHandler(resolution: EmittedResolution) {
    this.isSubstituteShelfVisible = false;
    this.exceptionResolved.emit(resolution);
  }

  searchForSubs(event) {
    const emittedSearchForSubs: EmittedSearchForSubs = {
      exceptionResolution: this.exceptionResolution,
      searchText: event.target.value,
    };
    this.searchForSubsClicked.emit(emittedSearchForSubs);
  }

  partialFlagResolveHandler(data: EmittedPartialFlag) {
    if (this.exceptionType === ExceptionType.PRODUCT_UNAVAILABLE) {
      this.isExpanded = !this.isExpanded;
    }
    this.partialFlagResolved.emit(data);
  }

  flipSubstituteProduct(data: EmittedFlippedProductNumber) {
    this.substituteProductFlipped.emit(data);
  }

  editRowHandler(data: ExceptionResolution) {
    this.editRowResolved.emit(data);
    this.showSubstitutesShelf();
  }

  cancelEdit(data: ExceptionResolution) {
    this.isSubstituteShelfVisible = false;
    this.cancelEditRow.emit(data);
  }

  trackByIndex = (index: number, id: any) => index;

  private updateHasSearchForSubs() {
    const selectedProductNumber =
      this.exceptionResolution?.resolutionOrderItem?.substituteProduct
        ?.productNumber;
    const subNumbers =
      this.exceptionResolution?.orderException?.subOrReplaceItems?.map(
        a => a.productNumber,
      );
    this.hasSearchForSubSelected =
      !!selectedProductNumber && !subNumbers.includes(selectedProductNumber);
  }

  showCompareProductsButton(exceptionResolution: ExceptionResolution): boolean {
    const doNotSub =
      !!exceptionResolution?.resolutionOrderItem &&
      !!exceptionResolution?.resolutionOrderItem?.originalProduct &&
      (exceptionResolution?.resolutionOrderItem?.substituteProduct === null ||
        exceptionResolution?.resolutionOrderItem?.substituteProduct ===
          undefined ||
        !exceptionResolution?.resolutionOrderItem?.substituteProduct);

    const reservedCheck =
      !(
        (this.exceptionType === this.exceptionTypeEnum.OUT_OF_STOCK ||
          this.exceptionType === this.exceptionTypeEnum.PRODUCT_UNAVAILABLE) &&
        (exceptionResolution?.orderItem?.unitsReserved !== 0 ||
          exceptionResolution?.orderItem?.eachesReserved !== 0)
      ) ||
      ((this.exceptionType === this.exceptionTypeEnum.OUT_OF_STOCK ||
        this.exceptionType === this.exceptionTypeEnum.PRODUCT_UNAVAILABLE) &&
        (exceptionResolution?.orderItem?.unitsReserved !== 0 ||
          exceptionResolution?.orderItem?.eachesReserved !== 0) &&
        !!exceptionResolution?.partialReserveFlag);

    return (
      !this.hideSearchForSubs &&
      exceptionResolution?.orderException?.subOrReplaceItems?.length > 0 &&
      !exceptionResolution?.resolutionOrderItem?.substituteProduct &&
      reservedCheck &&
      !doNotSub
    );
  }

  compareProductsClickHandler(exceptionResolution: ExceptionResolution) {
    this.compareProductsClicked.emit(exceptionResolution);
  }
}
